import { withStyles, Grid } from "@material-ui/core";
import React from "react";
import Header from "./Header";

const styles = (theme) => ({
    message:{
      color: theme.errorBorderColor,
      fontSize:12,
      padding:"0px 20px 20px 20px"
    }
})

const DispatchError = ({message, classes}) => {
    return (
      <>
      <Header label="Dispatch Error"  variant="error"/>
      <Grid item xs={12} className={classes.message}>
          {message}
      </Grid>
      </>
    )
}

export default withStyles(styles)(DispatchError)